import { render, staticRenderFns } from "./InlineFrame.vue?vue&type=template&id=a4c6bce6&"
import script from "./InlineFrame.vue?vue&type=script&lang=ts&"
export * from "./InlineFrame.vue?vue&type=script&lang=ts&"
import style0 from "./InlineFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
